import { Editor, Element } from 'slate';
import { getPrevious } from './get-previous';

export function getBlockPrevious<T extends Element>(editor: Editor, options?: Parameters<typeof getPrevious>[1]) {
    return getPrevious<T>(editor, {
        ...options,
        block: true,
    });
}
